import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.50001 1.32495C9.12722 1.32495 8.82501 1.62716 8.82501 1.99995V6.49995C8.82501 6.87274 9.12722 7.17495 9.50001 7.17495H14C14.3728 7.17495 14.675 6.87274 14.675 6.49995V1.99995C14.675 1.62716 14.3728 1.32495 14 1.32495H9.50001ZM10.175 5.82495V2.67495H13.325V5.82495H10.175Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.00001 8.82495C1.62722 8.82495 1.32501 9.12716 1.32501 9.49995V14C1.32501 14.3727 1.62722 14.675 2.00001 14.675H6.50001C6.8728 14.675 7.17501 14.3727 7.17501 14V9.49995C7.17501 9.12716 6.8728 8.82495 6.50001 8.82495H2.00001ZM2.67501 13.325V10.175H5.82501V13.325H2.67501Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3.41 1.88816C3.72903 1.25222 4.63332 1.24267 4.96573 1.87171L7.09797 5.90677C7.40589 6.4895 6.98342 7.19058 6.32434 7.19058H2.16782C1.51685 7.19058 1.09382 6.50508 1.38572 5.92322L3.41 1.88816ZM4.20307 3.31795L2.93754 5.84058H5.53609L4.20307 3.31795Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M14.75 11.7344C14.75 13.3912 13.4069 14.7344 11.75 14.7344C10.0931 14.7344 8.75 13.3912 8.75 11.7344C8.75 10.0775 10.0931 8.73438 11.75 8.73438C13.4069 8.73438 14.75 10.0775 14.75 11.7344ZM13.4 11.7344C13.4 12.6456 12.6613 13.3844 11.75 13.3844C10.8387 13.3844 10.1 12.6456 10.1 11.7344C10.1 10.8231 10.8387 10.0844 11.75 10.0844C12.6613 10.0844 13.4 10.8231 13.4 11.7344Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }